(function () {
    'use strict';

    angular.module("imApp").factory("persFactsService", [function () {
        let service = {};

        return service;
    }]);
})();
